import cloudyDay1 from '../Assets/Icons/cloudy-day-1.svg';
import cloudyDay2 from '../Assets/Icons/cloudy-day-2.svg';
import cloudyDay3 from '../Assets/Icons/cloudy-day-3.svg';
import cloudyNight1 from '../Assets/Icons/cloudy-night-1.svg';
import cloudyNight3 from '../Assets/Icons/cloudy-night-3.svg';
import cloudy from '../Assets/Icons/cloudy.svg';
import day from '../Assets/Icons/day.svg';
import night from '../Assets/Icons/night.svg';
import rainy3 from '../Assets/Icons/rainy-3.svg';
import rainy5 from '../Assets/Icons/rainy-5.svg';
import rainy6 from '../Assets/Icons/rainy-6.svg';
import rainy7 from '../Assets/Icons/rainy-7.svg';
import snowy6 from '../Assets/Icons/snowy-6.svg';
import thunder from '../Assets/Icons/thunder.svg';

export function getWeatherIcon(iconId: string) {
    switch (iconId) {
        default:
            return cloudyDay2;
        case '01d':
            return day;
        case '02d':
            return cloudyDay1;
        case '03d':
            return cloudy;
        case '04d':
            return cloudyDay3;
        case '09d':
            return rainy5;
        case '10d':
            return rainy3;
        case '11d':
            return thunder;
        case '13d':
            return snowy6;
        case '50d':
            return cloudy;
        case '01n':
            return night;
        case '02n':
            return cloudyNight1;
        case '03n':
            return cloudy;
        case '04n':
            return cloudyNight3;
        case '09n':
            return rainy6;
        case '10n':
            return rainy7;
        case '11n':
            return thunder;
        case '13n':
            return snowy6;
        case '50n':
            return cloudy;
    }
}
